import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { logout, fetchUserProfile } from '../slices/authSlice';

const AuthWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, token, user } = useSelector((state) => state.auth);

  useEffect(() => {
    const initAuth = async () => {
      if (token && !user) {
        try {
          await dispatch(fetchUserProfile()).unwrap();
        } catch (error) {
          dispatch(logout());
          navigate('/login', { replace: true });
        }
      }
    };

    initAuth();
  }, [dispatch, token, user, navigate]);

  if (loading && !user) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return children;
};

export default AuthWrapper;